import styled from 'styled-components';
import { breakpoints } from '@style-guide/config';

const CartActions = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  button {
    width: 100%;

    + button {
      margin-top: 20px;
    }
  }

  @media (min-width: ${breakpoints.l}) {
    flex-direction: row;

    button {
      width: auto;

      + button {
        margin-top: 0;
      }
    }
  }
`;

CartActions.displayName = 'CartActions';

export default CartActions;
